import Cookies from 'js-cookie'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import LoadingAndRefreshingToken from './LoadingAndRefreshingToken'

const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token)
    return Date.now() >= exp * 1000
  } catch {
    return true
  }
}

const PrivateRoute = (PrivateComponent) => {
  const Private = (props) => {
    const history = useHistory()

    // DEV BYPASS: Se REACT_APP_DEV_BYPASS=true, pula autenticação
    const devBypass = process.env.REACT_APP_DEV_BYPASS === 'true'
    if (devBypass) {
      console.warn('[DEV] Auth bypass enabled - DO NOT USE IN PRODUCTION')
      return <PrivateComponent {...props} />
    }

    const token = localStorage.getItem('access-token')
    const refreshToken = Cookies.get('refresh-token') // via Devise

    // Sem token → login
    if (!token) {
      history.push('/login')
      return null
    }

    // Token expirou
    if (isTokenExpired(token)) {
      if (refreshToken) {
        return <LoadingAndRefreshingToken />
      }
      history.push('/login')
      return null
    }

    return <PrivateComponent {...props} />
  }

  return Private
}

export default PrivateRoute
